module.exports = global["$"] = require("-!/root/workspace/chillylight_newTran_rAIk/node_modules/expose-loader/index.js?jQuery!./jquery.js");